import { Guid, IBaseModel } from '~/interfaces/base'

export class JobField implements IBaseModel {
  id!: Guid
  name!: string
  code!: string
}